<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="less">
@font-face {
  font-family: 'DINPro';
  src: url('./assets/font/DINPro-Black.otf') format('opentype'),
    url('./assets/font/DINPro-Bold.otf') format('opentype'),
    url('./assets/font/DINPro-Light.otf') format('opentype');
}
#app {
  width: 100%;
  font-family: Source Han Sans CN, Source,  'PingFang SC-Medium';
  // font-family: Source Han Sans CN, Source,  'PingFang SC-Medium', 'Helvetica Neue', Helvetica,
  //  'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial,
  //   sans-serif;
  // overflow: hidden;
}
@media (max-width: 900px) {
  #app {
    width: 1600px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue